import type { Notice } from '../tabs/contract';
import type { RankingEntry } from '../api/types';
import { fmtRemaining } from '../core/clock';

/** 自チームの順位（同点は同順位）。ranking が null・自チームが無いときは null */
export function rankOf(ranking: RankingEntry[] | null | undefined, teamId: string): number | null {
  if (!ranking) return null;
  const me = ranking.find((r) => r.team_id === teamId);
  if (!me) return null;
  return ranking.filter((r) => r.total > me.total).length + 1;
}

/** 帯の残り時間。終了時刻が無いときは --:-- */
export function fmtBandRemaining(ms: number | null): string {
  if (ms === null) return '--:--';
  return fmtRemaining(ms);
}

export function fmtScore(n: number): string {
  return n.toLocaleString('en-US');
}

export type QueueEffect = 'show' | 'dismiss-current' | 'none';

/**
 * 荷札の通知の順番待ち。表示中は current、待ちは pending。
 * タブの説明（sticky）が出ているときに通知が届いたら、先に説明を下げてから届いた順に出す。
 */
export class NoticeQueue {
  current: Notice | null = null;
  readonly pending: Notice[] = [];

  push(n: Notice): QueueEffect {
    this.pending.push(n);
    if (!this.current) return 'show';
    return this.current.sticky ? 'dismiss-current' : 'none';
  }

  /** 次を表示中にして返す（表示中なら null） */
  take(): Notice | null {
    if (this.current || this.pending.length === 0) return null;
    this.current = this.pending.shift() ?? null;
    return this.current;
  }

  /** 表示中の札を手放す */
  release(): void {
    this.current = null;
  }
}

/** タブの説明の文（README ⑬） */
export const TAB_INTRO: Record<'map' | 'book' | 'prompts' | 'cards', { name: string; text: string }> = {
  map: { name: 'マップ', text: '同エリアでクリアするほど倍率が上がります' },
  book: { name: '図鑑', text: 'スポットを押すと写真が提出できます' },
  prompts: { name: 'お題', text: '他チームと交渉し、お題を集めましょう' },
  cards: { name: 'カード', text: 'カードを使いゲームを有利に進めましょう' },
};
